import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useEventListener from 'root/hooks/useEventListener';
import isBrowser from 'utils/isBrowser';

import {
  Image
} from 'base-ui';

const PostCardAdInfo = ({ logo, bgColor, fontColor, borderColor, clientName, adType, changePosition }) => {
  const [position, setPosition] = useState('relative');

  const updatePosition = () => {
    // eslint-disable-next-line prefer-destructuring
    const scrollTop = document.documentElement.scrollTop;

    if (scrollTop > 100) {
      setPosition('fixed');
    } else {
      setPosition('relative');
    }
  };

  useEffect(() => {
    if (isBrowser() && changePosition) {
      updatePosition();
      useEventListener('scroll', () => updatePosition());
    }
  }, [isBrowser()]);

  return (
    <div style={{ position }} className={`ad-info font-small ${borderColor}-border ${bgColor}-bg ${fontColor}-color`}>
      <p>{adType}</p>
      <Image src={logo} alt={clientName} />
    </div>
  );
};

PostCardAdInfo.propTypes = {
  logo: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  borderColor: PropTypes.string,
  fontColor: PropTypes.string,
  clientName: PropTypes.string,
  adType: PropTypes.string,
  changePosition: PropTypes.bool
};

PostCardAdInfo.defaultProps = {
  bgColor: 'titles',
  borderColor: 'yellow',
  fontColor: 'regent-grey',
  clientName: 'client',
  adType: 'Especial Publi',
};

export default PostCardAdInfo;
